<template>
  <svg class="bg-icon" aria-hidden="true">
    <use :xlink:href="icon"></use>
  </svg>
</template>

<script>
  // import 'https://lf1-cdn-tos.bytegoofy.com/obj/iconpark/svg_19654_276.a6f498f0548aef0ed86561d8d2c9083c.js'
  import './iconpark.js'

  export default {
    props: {
      icon: {
        type: String,
        default: '',
      },
    },
  }
</script>
